import suppliersGroups from './suppliersGroups';
import suppliers from './suppliers';
export default {
    suppliersGroups,
    suppliers,
}